import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=057e7d34&"
import script from "./welfare.vue?vue&type=script&lang=js&"
export * from "./welfare.vue?vue&type=script&lang=js&"
import style0 from "./welfare.vue?vue&type=style&index=0&id=057e7d34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports